import {
    MdOutlineDashboard,
    MdOutlineVolunteerActivism,
    MdOutlinePayments,
    MdOutlineDiversity1,
    MdOutlineSavings,
    MdHelpOutline,
    MdOutlineAssignmentInd,
    MdOutlineCircle,
    MdOutlineLogout,
    MdAdd,
    MdAttachMoney,
    MdCircle,
    MdCheck,
    MdError,
    MdOutlinePhone,
    MdRemove,
    MdCheckCircleOutline,
    MdExpandMore,
    MdOutlineEdit,
    MdContentCopy,
    MdOutlineEmail,
    MdArrowUpward,
    MdArrowDownward,
    MdArrowBack,
    MdUnfoldMore,
    MdCheckCircle,
} from 'react-icons/md';
import { CiCircleMore } from 'react-icons/ci';
import {
    BiLoaderCircle,
    BiShareAlt,
    BiDownload,
    BiUpload,
} from 'react-icons/bi';
import { GiReceiveMoney } from 'react-icons/gi';
import { BsAsterisk } from 'react-icons/bs';
import { AiOutlineStop, AiOutlineCloseCircle } from 'react-icons/ai';
import { FaFacebookF, FaTwitter, FaFacebookMessenger } from 'react-icons/fa';

export const renderIcon = (icon: string, color = '#01aeb4') => {
    switch (icon) {
        case 'dashboard':
            return <MdOutlineDashboard />;
        case 'client':
            return <IconDigitalWellbeing />;
        case 'campaign':
            return <MdOutlineVolunteerActivism />;
        case 'expenses':
            return <MdOutlinePayments />;
        case 'team':
            return <MdOutlineDiversity1 />;
        case 'fundraisers':
            return <MdOutlineSavings />;
        case 'helpful-tools':
            return <MdHelpOutline />;
        case 'profile':
            return <MdOutlineAssignmentInd />;
        case 'logout':
            return <MdOutlineLogout />;
        case 'warning':
            // maroon circle with exclamation
            return <MdError color='#952e46' />;
        case 'complete':
            // green circle with checkmark
            return <MdCheckCircleOutline color={getDashColor('complete')} />;
        case 'incomplete':
        case 'unassigned':
            // yellow outline circle with ... 3 dots
            return <CiCircleMore color='orange' />;
        case 'pending':
            return <BiLoaderCircle />;
        case 'full_access':
        case 'full':
            // green circle filled in
            return <MdCircle color='#01aeb4' />;
        case 'limited_access':
        case 'limited':
            // orangey-yellow circle outline
            return <MdOutlineCircle color='#fdbf3c' />;
        case 'no_access':
            // black circle outline
            return <MdOutlineCircle color='#000' />;
        case 'phone_access':
        case 'primary':
            return <MdOutlinePhone />;
        case 'funds_inquiry':
            // green dollar sign
            return <MdAttachMoney color='#afc12d' />;
        case 'funds_request':
            // green hand receiving coins
            return <GiReceiveMoney />;
        case 'emergency_contact':
            // red asterisk
            return <BsAsterisk color='#952e46' />;
        case 'funded':
            // green circle with checkmark
            return <MdCheckCircleOutline color='#01aeb4' />;
        case 'share':
            return <BiShareAlt color='#01aeb4' />;
        case 'expand':
            return <MdExpandMore />;
        case 'download':
            return <BiDownload />;
        case 'upload':
            return <BiUpload />;
        case 'add':
            return <MdAdd />;
        case 'edit':
            // green pencil
            return <MdOutlineEdit color='#01aeb4' />;
        case 'edit_default':
            //  pencil
            return <MdOutlineEdit />;
        case 'check':
            return <MdCheck />;
        case 'delete':
            return <AiOutlineStop />;
        case 'close':
            return <AiOutlineCloseCircle />;
        case 'copy':
            return <MdContentCopy color={color} />;
        case 'facebook':
            return <FaFacebookF />;
        case 'twitter':
            return <FaTwitter />;
        case 'messenger':
            return <FaFacebookMessenger />;
        case 'email':
            return <MdOutlineEmail />;
        case 'arrow_up':
            return <MdArrowUpward />;
        case 'arrow_down':
            return <MdArrowDownward />;
        case 'arrow_left':
            return <MdArrowBack />;
        case 'double_arrow':
            return <MdUnfoldMore />;
        case 'my_id':
            return <BsAsterisk size={16} />;
        case 'success':
            return <MdCheckCircle color='#afc12d' />;
        default:
            return '';
    }
};

export const toggleIcon = (open: boolean = false) => {
    if (open) {
        return <MdRemove />;
    }
    return <MdAdd />;
};

export const getDashColor = (color: string) => {
    // console.log("getDashColor()", color)
    switch (color) {
        case 'warning':
            return '#f47d29';
        case 'disbursements':
            return 'rgba(244, 125, 41, 0.1)';
        case 'disbursements_text':
            return '#f47d29';
        case 'supporters':
            return 'rgba(1, 174, 180, 0.1)';
        case 'supporters_text':
            return '#01aeb4';
        case 'guestbook':
            return 'rgba(143, 142, 36, 0.1)';
        case 'guestbook_text':
            return '#8f8e24';
        case 'friends':
            return 'rgba(235, 235, 235, 0.4)';
        case 'friends_text':
            return '#131212';
        case 'pending_verification':
            return 'rgba(254, 191, 62, 0.1)';
        case 'fundraising':
            return '#01aeb4';
        case 'campaign_materials':
            return '#ebebeb';
        case 'message':
            return '#952e46';
        case 'green_font':
            return '#01aeb4';
        case 'application_complete':
            return '#01aeb4';
        case 'complete':
            return '#01aeb4';
        case 'incomplete':
            return '#fdbf3c';
        case 'my-id':
            return '#f5eaec';
        case 'my-id_text_color':
            return '#952e46';
        case 'redeem-button':
            return '#febf3f';
        case 'Pending Medical Professional Verification':
            return '#fdbf3c';
        default:
            return '';
    }
};

export const HorizontalLine = () => {
    return (
        <hr style={{ background: 'darkgrey', height: '2px', border: 'none' }} />
    );
};

export const BlueHorizontalLine = () => {
    return (
        <hr
            style={{
                display: 'block',
                height: 1,
                border: 0,
                borderTop: '1px solid #01aeb4',
                margin: '0.5em 0',
                padding: '0px 0px 0px 15px ',
            }}
        />
    );
};

export const IconBurger = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
        >
            <mask
                id='mask0_8388_1322'
                // style='mask-type:alpha'
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='24'
                height='24'
            >
                <rect width='24' height='24' fill='#D9D9D9' />
            </mask>
            <g mask='url(#mask0_8388_1322)'>
                <path
                    d='M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z'
                    fill='#0D0106'
                />
            </g>
        </svg>
    );
};

export const IconVerified = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
        >
            <path
                d='M7.6 21.5L5.7 18.3L2.1 17.5L2.45 13.8L0 11L2.45 8.2L2.1 4.5L5.7 3.7L7.6 0.5L11 1.95L14.4 0.5L16.3 3.7L19.9 4.5L19.55 8.2L22 11L19.55 13.8L19.9 17.5L16.3 18.3L14.4 21.5L11 20.05L7.6 21.5ZM9.95 14.55L15.6 8.9L14.2 7.45L9.95 11.7L7.8 9.6L6.4 11L9.95 14.55Z'
                fill='#AFC12D'
            />
        </svg>
    );
};

export const IconDigitalWellbeing = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='25'
            viewBox='0 0 24 25'
            fill='none'
        >
            <path
                d='M12 9.48877C11.0333 9.48877 10.2083 9.1471 9.525 8.46377C8.84167 7.78044 8.5 6.95544 8.5 5.98877C8.5 5.0221 8.84167 4.1971 9.525 3.51377C10.2083 2.83044 11.0333 2.48877 12 2.48877C12.9667 2.48877 13.7917 2.83044 14.475 3.51377C15.1583 4.1971 15.5 5.0221 15.5 5.98877C15.5 6.95544 15.1583 7.78044 14.475 8.46377C13.7917 9.1471 12.9667 9.48877 12 9.48877ZM12 7.48877C12.4167 7.48877 12.7708 7.34294 13.0625 7.05127C13.3542 6.7596 13.5 6.40544 13.5 5.98877C13.5 5.5721 13.3542 5.21794 13.0625 4.92627C12.7708 4.6346 12.4167 4.48877 12 4.48877C11.5833 4.48877 11.2292 4.6346 10.9375 4.92627C10.6458 5.21794 10.5 5.5721 10.5 5.98877C10.5 6.40544 10.6458 6.7596 10.9375 7.05127C11.2292 7.34294 11.5833 7.48877 12 7.48877ZM12 22.4888L6 16.4888C5.66667 16.1554 5.41667 15.7804 5.25 15.3638C5.08333 14.9471 5 14.4888 5 13.9888C5 13.0054 5.3375 12.1763 6.0125 11.5013C6.6875 10.8263 7.51667 10.4888 8.5 10.4888C8.98333 10.4888 9.42917 10.5804 9.8375 10.7638C10.2458 10.9471 10.6167 11.2054 10.95 11.5388L12 12.5888L13.05 11.5388C13.3833 11.2054 13.7542 10.9471 14.1625 10.7638C14.5708 10.5804 15.0167 10.4888 15.5 10.4888C16.4833 10.4888 17.3125 10.8263 17.9875 11.5013C18.6625 12.1763 19 13.0054 19 13.9888C19 14.4888 18.9167 14.9471 18.75 15.3638C18.5833 15.7804 18.3333 16.1554 18 16.4888L12 22.4888ZM12 19.6388L16.55 15.0888C16.7 14.9388 16.8125 14.7679 16.8875 14.5763C16.9625 14.3846 17 14.1888 17 13.9888C17 13.5888 16.8583 13.2388 16.575 12.9388C16.2917 12.6388 15.9333 12.4888 15.5 12.4888C15.3 12.4888 15.1208 12.5179 14.9625 12.5763C14.8042 12.6346 14.65 12.7388 14.5 12.8888L12 15.3888L9.5 12.8888C9.4 12.7888 9.27083 12.6971 9.1125 12.6138C8.95417 12.5304 8.75 12.4888 8.5 12.4888C8.06667 12.4888 7.70833 12.6388 7.425 12.9388C7.14167 13.2388 7 13.5888 7 13.9888C7 14.1888 7.04167 14.3763 7.125 14.5513C7.20833 14.7263 7.31667 14.8888 7.45 15.0388L12 19.6388Z'
                fill='currentColor'
            />
        </svg>
    );
};

export const IconSwap = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M4 20V18H6.75L6.35 17.65C5.48333 16.8833 4.875 16.0083 4.525 15.025C4.175 14.0417 4 13.05 4 12.05C4 10.2 4.55417 8.55417 5.6625 7.1125C6.77083 5.67083 8.21667 4.71667 10 4.25V6.35C8.8 6.78333 7.83333 7.52083 7.1 8.5625C6.36667 9.60417 6 10.7667 6 12.05C6 12.8 6.14167 13.5292 6.425 14.2375C6.70833 14.9458 7.15 15.6 7.75 16.2L8 16.45V14H10V20H4ZM14 19.75V17.65C15.2 17.2167 16.1667 16.4792 16.9 15.4375C17.6333 14.3958 18 13.2333 18 11.95C18 11.2 17.8583 10.4708 17.575 9.7625C17.2917 9.05417 16.85 8.4 16.25 7.8L16 7.55V10H14V4H20V6H17.25L17.65 6.35C18.4667 7.16667 19.0625 8.05417 19.4375 9.0125C19.8125 9.97083 20 10.95 20 11.95C20 13.8 19.4458 15.4458 18.3375 16.8875C17.2292 18.3292 15.7833 19.2833 14 19.75Z'
                fill={'#01aeb4'}
            />
        </svg>
    );
};

export const Bold = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <path d='M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z'></path>
        <path d='M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z'></path>
    </svg>
);

export const Underline = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <path d='M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3'></path>
        <line x1='4' y1='21' x2='20' y2='21'></line>
    </svg>
);

export const Italic = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <path d='M19 4h-9M14 20H5M14.7 4.7L9.2 19.4' />
    </svg>
);

export const Link = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <path d='M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71'></path>
        <path d='M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71'></path>
    </svg>
);

export const Code = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <polyline points='16 18 22 12 16 6'></polyline>
        <polyline points='8 6 2 12 8 18'></polyline>
    </svg>
);

export const Strikethrough = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <path d='M17.3 4.9c-2.3-.6-4.4-1-6.2-.9-2.7 0-5.3.7-5.3 3.6 0 1.5 1.8 3.3 3.6 3.9h.2m8.2 3.7c.3.4.4.8.4 1.3 0 2.9-2.7 3.6-6.2 3.6-2.3 0-4.4-.3-6.2-.9M4 11.5h16' />
    </svg>
);

export const RotateLeft = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <path d='M2.5 2v6h6M2.66 15.57a10 10 0 1 0 .57-8.38' />
    </svg>
);

export const RotateRight = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <path d='M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38' />
    </svg>
);

export const X = ({ size = 16, color = 'currentColor' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <line x1='18' y1='6' x2='6' y2='18'></line>
        <line x1='6' y1='6' x2='18' y2='18'></line>
    </svg>
);
